/* eslint-disable max-len */
import React from 'react';

const AddColorIcon = props => (
  <svg width={25} height={25} viewBox="0 0 25 25" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 12h4.8c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H13v4.8a.2.2 0 0 1-.2.2h-.6a.2.2 0 0 1-.2-.2V13H7.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2H12V7.2c0-.11.09-.2.2-.2h.6c.11 0 .2.09.2.2V12zm-.5 13C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.851 24 24 18.851 24 12.5S18.851 1 12.5 1 1 6.149 1 12.5 6.149 24 12.5 24z"
    />
  </svg>
);

export default AddColorIcon;
